<div class="ca-page">
  <!-- Header -->
  <div class="ca-header">
    <div class="ca-header-left">
      <span class="material-icons ca-header-icon">chat</span>
      <div>
        <h2 class="ca-title">Complaint Assist Logs</h2>
        <p class="ca-subtitle">Chatbot-assisted complaint conversations</p>
      </div>
    </div>
    <div class="ca-badge" *ngIf="!isLoading">{{ logs.length }} records</div>
  </div>

  <!-- Filter Bar -->
  <div class="ca-filter-bar">
    <div class="ca-filter-group">
      <label class="ca-label">Date From</label>
      <input type="date" class="ca-input" [(ngModel)]="fromDate" />
    </div>
    <div class="ca-filter-group">
      <label class="ca-label">Date To</label>
      <input type="date" class="ca-input" [(ngModel)]="toDate" />
    </div>
    <div class="ca-filter-actions">
      <button class="ca-btn ca-btn-apply" (click)="applyFilters()">Apply</button>
      <button class="ca-btn ca-btn-clear" (click)="clearFilters()">Clear</button>
    </div>
  </div>
  <div class="ca-date-error" *ngIf="dateError">{{ dateError }}</div>

  <!-- Table -->
  <div class="ca-table-wrap">
    <table class="ca-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Complaint No</th>
          <th>Created At</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="isLoading">
          <tr *ngFor="let s of skeletonRows" class="ca-skeleton-row">
            <td><span class="ca-skeleton"></span></td>
            <td><span class="ca-skeleton"></span></td>
            <td><span class="ca-skeleton"></span></td>
            <td><span class="ca-skeleton ca-skeleton-sm"></span></td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!isLoading">
          <tr *ngIf="logs.length === 0">
            <td colspan="4" class="ca-empty">No records found.</td>
          </tr>
          <tr *ngFor="let log of pagedLogs; let i = index" class="ca-data-row">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td class="ca-complaint-no">{{ log.complaintNo }}</td>
            <td>{{ formatDate(log.createdAt) }}</td>
            <td>
              <button class="ca-btn-view" (click)="openModal(log)">
                <span class="material-icons">visibility</span>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <!-- Pagination Footer -->
    <div class="ca-pagination" *ngIf="!isLoading && logs.length > 0">
      <div class="ca-pagination-left">
        <button class="ca-page-btn" (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
        <button class="ca-page-btn ca-page-btn-next" (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
        <span class="ca-page-info">Page {{ currentPage }} of {{ totalPages }}</span>
      </div>
      <div class="ca-pagination-right">
        <span class="ca-page-total">{{ logs.length }} records</span>
        <label class="ca-label">Rows per page</label>
        <select class="ca-page-select" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">
          <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
        </select>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="ca-modal-overlay" *ngIf="showModal">
  <div class="ca-modal">
    <div class="ca-modal-header">
      <div class="ca-modal-title-row">
        <span class="material-icons">chat</span>
        <span class="ca-modal-title">Conversation — {{ selectedLog?.complaintNo }}</span>
      </div>
      <button class="ca-modal-close" (click)="closeModal()">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="ca-modal-meta" *ngIf="selectedLog">
      <span>{{ formatDate(selectedLog.createdAt) }}</span>
    </div>
    <div class="ca-modal-body">
      <div class="ca-chat-window">
        <div
          *ngFor="let msg of parsedMessages"
          class="ca-bubble-row"
          [class.ca-row-bot]="msg.sender === 'bot'"
          [class.ca-row-user]="msg.sender === 'user'">
          <div class="ca-avatar" *ngIf="msg.sender === 'bot'">
            <span class="material-icons">smart_toy</span>
          </div>
          <div class="ca-bubble" [class.ca-bubble-bot]="msg.sender === 'bot'" [class.ca-bubble-user]="msg.sender === 'user'">
            {{ msg.text }}
          </div>
          <div class="ca-avatar ca-avatar-user" *ngIf="msg.sender === 'user'">
            <span class="material-icons">person</span>
          </div>
        </div>
        <div *ngIf="parsedMessages.length === 0" class="ca-empty">No conversation data.</div>
      </div>
    </div>
  </div>
</div>
